module.exports = __webpack_public_path__ + "static/media/may-pdf.6879de41.jpg";